import { render, staticRenderFns } from "./GroupOptimizationItem.vue?vue&type=template&id=f0b15fde"
import script from "./GroupOptimizationItem.vue?vue&type=script&lang=js"
export * from "./GroupOptimizationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports